import { Component, DestroyRef, inject, signal } from '@angular/core';
import { IconBigMediumStern, IconBigMediumSternGefuellt, IconComponent } from '@big-direkt/utils/icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { ChatService } from '../../../services/chat.service';

@Component({
    selector: 'big-chat-rating',
    templateUrl: './rating.component.html',
    imports: [IconComponent],
})
export class RatingComponent {
    private readonly api = inject(ApiService);
    private readonly chatService = inject(ChatService);
    private readonly destroyRef = inject(DestroyRef);

    public readonly config = this.chatService.config;
    public readonly currentRating = signal(0);
    public readonly iconStar = IconBigMediumStern;
    public readonly iconStarFilled = IconBigMediumSternGefuellt;

    public wasClicked = false;

    public handleIconHover(rate: number): void {
        if (this.wasClicked) {
            return;
        }

        this.currentRating.set(rate);
    }

    public rateConversation(value: number): void {
        this.currentRating.set(value);
        void firstValueFrom(this.api.rateConversation(value).pipe(takeUntilDestroyed(this.destroyRef)));
    }
}
